import { sendEvent } from '../../../configs/firebase'

export type EvaluatedServicesMonthDirection = 'previous' | 'next'

const ratingScreenAnalytics = {
  trackScreenView(): void {
    sendEvent('evaluated_services_screen_view', {
      screen_name: 'EvaluatedServices',
      screen_class: 'Rating',
    })
  },

  trackMonthFilterChange(params: {
    direction: EvaluatedServicesMonthDirection
    /** Período exibido antes da navegação, `YYYY-MM`. */
    from_period: string
  }): void {
    sendEvent('evaluated_services_month_filter', params)
  },

  trackCsatLoaded(params: {
    doctor_id: string
    /** Mês do filtro, `YYYY-MM`. */
    period: string
    comments_count: number
  }): void {
    sendEvent('evaluated_services_csat_loaded', params)
  },

  /** Média fixa vinda de `/me` (campo `rating`). */
  trackDoctorRatingLoaded(rating_value: number): void {
    sendEvent('evaluated_services_doctor_rating_loaded', { rating_value })
  },
}

export default ratingScreenAnalytics
